import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from "@angular/forms";
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {ImageUploadModule} from "../../lib/image-upload/image-upload.module";
import { ShareTrackExpiryReportModalComponent } from './share-track-expiry-report-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import {ButtonModule, DropdownModule, InputsModule} from "@xref/xref-lib";

@NgModule({
    declarations: [ShareTrackExpiryReportModalComponent],
    imports: [
      CommonModule,
      FormsModule,
      AlertMessageModule,
      TooltipModule.forRoot(),
      ImageUploadModule,
      ReactiveFormsModule,
      ButtonModule,
      DropdownModule,
      InputsModule
    ],
    exports: [ShareTrackExpiryReportModalComponent]
  })
  export class ShareTrackExpiryReportModalModule {
  }
